import { LAZYLOADED_CLASS_NAME } from '../../classnames/lazyload';
import { SOCIAL_VIDEO } from '../../classnames/video';

export default class Base {
  eventName = 'lazybeforeunveil';

  initialize = (container = document) => {
    const mediaOutsideViewport = [...container.querySelectorAll(`${this.selector}:not(.${SOCIAL_VIDEO})`)];
    const mediaInsideViewport = [...container.querySelectorAll(`${this.selector}.${LAZYLOADED_CLASS_NAME}`)];

    mediaOutsideViewport.forEach(
      (element) => element.addEventListener(this.eventName, ({ target }) => {
        this.load(target);
      })
    );

    mediaInsideViewport.forEach(this.load);
  };
}
